import ClpTable from "components/ClpTable"
import { t } from "i18next"

export const NoReportSelectedTable = () => {
  return (
    <ClpTable
      rows={[
        {
          loadingReport: t("global.downloading_report", "Downloading report..")
        }
      ]}
      columns={[
        {
          accessorKey: "noSelectedReport",
          header: t("global.no_rows", "No rows")
        }
      ]}
      loadingState={2}
    />
  )
}
